import { render, staticRenderFns } from "./Upload-image.vue?vue&type=template&id=1aa3957e"
import script from "./Upload-image.vue?vue&type=script&lang=js"
export * from "./Upload-image.vue?vue&type=script&lang=js"
import style0 from "./Upload-image.vue?vue&type=style&index=0&id=1aa3957e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports